import {
    Button, CardContent, FormControl, FormControlLabel, FormGroup, Switch, TextField,
    FormLabel, RadioGroup, Radio, FormHelperText, Checkbox
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import api from '../../../services/api';
import Box from '@material-ui/core/Box';
import { ASIM, ANAO, ACLASSE_TIPO_VEIC_AUTOMOVEL, ACLASSE_TIPO_VEIC_CAMINHAO, ACLASSE_TIPO_VEIC_CAVALOMECANICO, ACLASSE_TIPO_VEIC_EMPILHADEIRA, ACLASSE_TIPO_VEIC_MAQUINA, ACLASSE_TIPO_VEIC_MOTOCICLETA, ACLASSE_TIPO_VEIC_NENHUM, ACLASSE_TIPO_VEIC_ONIBUS, ACLASSE_TIPO_VEIC_REBOQUE_SEMIREBOQUE, ACLASSE_TIPO_VEIC_SUPERDIMENSIONADO, ACLASSE_TIPO_VEIC_UTILITARIO } from '../../../consts';
import PropTypes from 'prop-types';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { validateField } from 'lib/functions';

class TipoVeiculoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isNewRecord: false,
            isView: false,
            tipoveiculo: {
                desctipoveiculo: '',
                capacidadepax: '',
                classe: '',
                obs: '',
                codtipoveiculo: '',
                inativo: ANAO // Valor padrão
            },
            errors: {},
            classes: {},
            schema: {
                desctipoveiculo: {
                    presence: { allowEmpty: false, message: 'Tipo veículo obrigatório!' },
                    length: { maximum: 64 },
                    type: 'integer'
                },
                capacidadepax: {
                    presence: { allowEmpty: false, message: 'Capacidade pax obrigatória!' },
                    length: { maximum: 64 },
                    type: 'integer'
                }
            },

            useStyles: makeStyles(theme => ({
                root: {
                    backgroundColor: theme.palette.background.default,
                    height: '100%'
                },
                grid: {
                    height: '100%'
                },
                quoteContainer: {
                    [theme.breakpoints.down('md')]: {
                        display: 'none'
                    }
                },
                quote: {
                    backgroundColor: theme.palette.neutral,
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundImage: 'url(/images/auth.jpg)',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                },
                quoteInner: {
                    textAlign: 'center',
                    flexBasis: '600px'
                },
                quoteText: {
                    color: theme.palette.white,
                    fontWeight: 300
                },
                name: {
                    marginTop: theme.spacing(3),
                    color: theme.palette.white
                },
                bio: {
                    color: theme.palette.white
                },
                contentContainer: {},
                content: {
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                },
                contentHeader: {
                    display: 'flex',
                    alignItems: 'center',
                    paddingTop: theme.spacing(5),
                    paddingBototm: theme.spacing(2),
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2)
                },
                logoImage: {
                    marginLeft: theme.spacing(4)
                },
                contentBody: {
                    flexGrow: 1,
                    display: 'flex',
                    alignItems: 'center',
                    [theme.breakpoints.down('md')]: {
                        justifyContent: 'center'
                    }
                },
                form: {
                    paddingLeft: 100,
                    paddingRight: 100,
                    paddingBottom: 125,
                    flexBasis: 700,
                    [theme.breakpoints.down('sm')]: {
                        paddingLeft: theme.spacing(2),
                        paddingRight: theme.spacing(2)
                    }
                },
                title: {
                    marginTop: theme.spacing(3)
                },
                socialButtons: {
                    marginTop: theme.spacing(3)
                },
                socialIcon: {
                    marginRight: theme.spacing(1)
                },
                sugestion: {
                    marginTop: theme.spacing(2)
                },
                textField: {
                    marginTop: theme.spacing(2)
                },
                signInButton: {
                    margin: theme.spacing(2, 0)
                },
                alert: {
                    color: '#FF0000',
                }
            })),
        };
    }

    async componentDidMount() {
        // carrega informações formulário
        const { id } = this.props.match.params;
        const { location } = this.props;
        const currentPath = location.pathname;

        if (id >= 0) {
            try {
                const response = await api.get(`/tipoveiculo/${id}`);
                const dados = response.data[0] || {};

                console.log('DADOS RECEBIDOS DO BACKEND:', JSON.stringify(dados, null, 2));

                this.setState({
                    tipoveiculo: response.data[0],
                    classe: response.data[0].classe ? String(response.data[0].classe) : String(ACLASSE_TIPO_VEIC_NENHUM),
                    obs: dados.obs || '',
                    isNewRecord: false,
                    isView: currentPath.includes('/view')
                });

                const tiposveiculos = await api.get(`/tipoveiculo/listforchange/${response.data[0].codtipoveiculo}`);
                this.setState({ tiposveiculos: tiposveiculos.data });
            } catch (error) {
                console.error('Erro ao carregar:', error);
            }
        }

        else if (id === 'novo') {
            this.setState({
                isNewRecord: true,
                tipoveiculo: {
                    ...this.state.tipoveiculo,
                    obs: ''
                }
            });
        }
    }

    /* evento on change componentes */
    OnChange = (event) => {
        const { name, type, value, checked } = event.target;

        // Não converter para Uppercase
        if (name === 'obs') {
            this.setState(prevState => ({
                tipoveiculo: {
                    ...prevState.tipoveiculo,
                    [name]: value
                }
            }));
            return;
        }

        // Demais campos (código existente)
        let adjustedValue =
            type === 'checkbox' ? (checked ? ASIM : ANAO) :
                type === 'radio' ? Number(value) : value.toUpperCase();

        this.setState(prevState => ({
            tipoveiculo: {
                ...prevState.tipoveiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* atualiza dados de tipo de veículo existente - post */
    atualizaTipoVeiculo = async () => {
        const { tipoveiculo } = this.state;
        try {
            const response = await api.put(`/tipoveiculo/${tipoveiculo.desctipoveiculo}`, tipoveiculo);
            if (response.status === 200) {
                this.props.history.push('/frotas/tipoveiculo');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    }

    /* Click salvar */
    onClickSave = async () => {
        const { tipoveiculo } = this.state;
        const formData = new FormData();

        // Obtém o código do usuário dinamicamente
        const codusuarioregistrou = sessionStorage.getItem('codUser') || localStorage.getItem('codUser');

        if (!codusuarioregistrou) {
            console.erro('Erro: Código do usuário não encontrado!');
        }

        formData.append('desctipoveiculo', tipoveiculo.desctipoveiculo || '');
        formData.append('capacidadepax', tipoveiculo.capacidadepax || '');
        formData.append('classe', tipoveiculo.classe || '');
        formData.append('obs', tipoveiculo.obs || '');
        formData.append('inativo', tipoveiculo.inativo || '');
        formData.append('codusuarioregistrou', Number(codusuarioregistrou));

        try {
            await api.post('/tipoveiculo', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (this.props.loadTiposVeiculo) this.props.loadTiposVeiculo();
            this.props.history.push('/frotas/tipoveiculo');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);
        }

        let errors = {};
        errors = this.validationRequiredFields();
        this.setState({ errors });
        if (Object.keys(errors).length === 0) {
            if (this.state.isNewRecord) {
                this.insereTipoVeiculo()
            }
            else {
                this.atualizaTipoVeiculo();
            }
        }
    }

    /* Click cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/tipoveiculo');
    }

    /* valida campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { schema } = this.state;
        const { tipoveiculo } = this.state;
        let errors = {};

        // Valida campos gerais do schema
        const requiredFields = [
            'desctipoveiculo',
            'capacidadepax'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, tipoveiculo[field], schema);
            if (error) {
                errors[field] = error;
            }
        })

        return errors;
    }

    /* insere novo tipo de veículo */
    insereTipoVeiculo = async () => {
        const { tipoveiculo } = this.state;
        tipoveiculo.codusuarioregistrou = parseInt(sessionStorage.getItem('codUser'));
        try {
            const response = await api.post(`/tipoveiculo`, tipoveiculo);
            if (response.status === 200) {
                this.props.history.push('/frotas/tipoveiculo');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    render() {
        const { tipoveiculo } = this.state;
        const { classes } = this.state;
        const { errors } = this.state;

        return (
            <div>
                <CardContent>
                    <Typography
                        component="h1"
                        variant="h3"
                    >
                        Tipo de veículo {tipoveiculo.codtipoveiculo}
                    </Typography>

                    <br />

                    <FormGroup>
                        <TextField
                            className={this.state.useStyles.textField}
                            label="Tipo de veículo"
                            style={{ marginTop: '10px', width: "95.5%" }}
                            name="desctipoveiculo"
                            value={tipoveiculo.desctipoveiculo || ''}
                            variant="outlined"
                            onChange={this.OnChange}
                            helperText={errors.desctipoveiculo || ''}
                            error={!!errors.desctipoveiculo}
                            disabled={this.state.isView}
                            inputProps={{ maxLength: 50 }}
                        />
                    </FormGroup>

                    <br />

                    <Box width="100%">
                        <FormControl
                            className={classes.textField}
                            style={{ marginRight: "1rem", width: "45%" }}
                            variant="filled"
                            disabled={this.state.isView}

                        >
                            <InputLabel
                                htmlFor="outlined-age-native-simple"
                                shrink={true} // Isso evita a sobreposição
                                style={{ padding: '0 4px' }} // Estilo adicional para melhor visualização
                            >
                                Classe de Veículo
                            </InputLabel>

                            <Select
                                inputProps={{
                                    id: 'outlined-age-native-simple',
                                    name: 'classe'
                                }}
                                label="Classe de Veículo"
                                native
                                onChange={this.OnChange}
                                value={this.state.tipoveiculo.classe || String(ACLASSE_TIPO_VEIC_NENHUM)} // Usa o estado correto
                            >
                                <option
                                    key={ACLASSE_TIPO_VEIC_NENHUM}
                                    value={ACLASSE_TIPO_VEIC_NENHUM}
                                >
                                    {"Nenhum"}</option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_CAMINHAO}
                                    value={ACLASSE_TIPO_VEIC_CAMINHAO}
                                >
                                    {"Caminhão"}</option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_AUTOMOVEL}
                                    value={ACLASSE_TIPO_VEIC_AUTOMOVEL}
                                >
                                    {"Automóvel"}</option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_UTILITARIO}
                                    value={ACLASSE_TIPO_VEIC_UTILITARIO}
                                >
                                    {"Utilitário"}</option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_ONIBUS}
                                    value={ACLASSE_TIPO_VEIC_ONIBUS}
                                >
                                    {"Ônibus"}</option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_REBOQUE_SEMIREBOQUE}
                                    value={ACLASSE_TIPO_VEIC_REBOQUE_SEMIREBOQUE}
                                >
                                    {"Reboque/semirreboque"}</option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_EMPILHADEIRA}
                                    value={ACLASSE_TIPO_VEIC_EMPILHADEIRA}
                                >
                                    {"Empilhadeira"}</option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_MOTOCICLETA}
                                    value={ACLASSE_TIPO_VEIC_MOTOCICLETA}
                                >
                                    {"Motocicleta"}</option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_MAQUINA}
                                    value={ACLASSE_TIPO_VEIC_MAQUINA}
                                >
                                    {"Máquina"}</option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_SUPERDIMENSIONADO}
                                    value={ACLASSE_TIPO_VEIC_SUPERDIMENSIONADO}
                                >
                                    {"Superdimensionado"}</option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_CAVALOMECANICO}
                                    value={ACLASSE_TIPO_VEIC_CAVALOMECANICO}
                                >
                                    {"Cavalo mecânico"}</option>
                            </Select>
                        </FormControl>

                        <TextField
                            className={this.state.useStyles.textField}
                            label="Capacidade Pax"
                            style={{ marginRight: "0.5rem", width: '49%' }}
                            name="capacidadepax"
                            value={tipoveiculo.capacidadepax || ''}
                            variant="outlined"
                            onChange={this.OnChange}
                            error={!!errors.capacidadepax}
                            disabled={this.state.isView}
                            type="number"
                            helperText={errors.capacidadepax || ''}
                        />
                    </Box>

                    <br />

                    <Typography
                        color="textSecondary"
                        component="p"
                        variant="body2"

                    > Observação
                    </Typography>
                    <FormGroup className={classes.formGroup}>
                        <textarea
                            id="obs"
                            name="obs"
                            onChange={this.OnChange}
                            className={classes.textarea}
                            value={tipoveiculo.obs}
                            disabled={this.state.isView}
                            style={{
                                width: '100%',
                                minHeigth: '100px',
                                padding: '8px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                fontFamily: 'Arial, sans-serif'
                            }}
                        />
                    </FormGroup>

                    <br />
                    <br />
                    <br />

                    <FormControlLabel
                        control={
                            <Switch
                                checked={!(tipoveiculo.inativo === ASIM)}
                                name="inativo"
                                onChange={this.OnChange}
                                color="primary"
                                disabled={this.state.isView}
                            />
                        }
                        label={(tipoveiculo.inativo === ASIM) ? 'Inativo' : 'Ativo'}
                    />

                    <br />
                    <br />
                    <br />

                    <Button
                        name="salvar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickSave}
                        style={{ marginTop: '10px' }}
                        disabled={this.state.isView}
                    >
                        Salvar
                    </Button>

                    <Button
                        name="cancelar"
                        variant="contained"
                        onClick={this.onClickCancel}
                        style={{ marginTop: '10px', marginLeft: '10px' }}
                        color="secondary"
                    >
                        Cancelar
                    </Button>
                </CardContent>

                <AlertInformation
                    open={this.state.openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={this.state.messageAlert}
                />
            </div >
        );
    }
}

TipoVeiculoForm.propTypes =
{
    classes: PropTypes.object.isRequired
};

export default TipoVeiculoForm;